import { color, maxWidth, space } from "@/lib/design-tokens";
import { shop } from "@/lib/copy/shop";

export type CatalogStatus = { state: "live" | "stale" | "unavailable"; observed_at?: string | null };

export function CatalogNotice({ status }: { status?: CatalogStatus }) {
  if (!status || status.state === "live") return null;
  return (
    <aside role="status" style={{ background: color.surface, color: color.ink }}>
      <div style={{ maxWidth, margin: "0 auto", padding: `24px ${space.gutter}`, lineHeight: 1.6 }}>
        <strong>{status.state === "stale" ? "Our bike list is being refreshed." : "We can’t load the bike list right now."}</strong>{" "}
        {status.state === "stale" && "These are the bikes we last checked. Please confirm prices and availability with us. "}
        <a href={shop.phoneHref} style={{ color: color.blue, textDecoration: "underline" }}>Call the shop</a> for the latest.
      </div>
    </aside>
  );
}
